var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-card"},[_c('div',{staticClass:"card col-md-6"},[_c('h3',[_vm._v("Expunerea la mediul înconjurător")]),_c('p',[_vm._v("trebuie să se facă treptat astfel încât organismul să se acomodeze cu factorii de mediu. ")])])])
}]

export { render, staticRenderFns }